export const ResponseStatus = {
    UNKNOWN: 'unknown',
    ERROR: 'error',
    SUCCESS: 'success',
    WARNING: 'warning',
    INFO: 'info',
    FIELDS_VALIDATION: 'fields_validation'
};

export const getFormData = (object: any) => {
    return objectToFormData(object);
};

export const objectToFormData = (data: any, formData: FormData = new FormData()) => {
    let indexFiles = 0;
    Object.keys(data).forEach((key) => {
        if (data[key] === undefined) {
            return;
        }
        if (data[key] instanceof File) {
            formData.append(key, data[key]);
        } else if (Array.isArray(data[key]) || data[key] instanceof Object) {
            if (Array.isArray(data[key])) {
                data[key].forEach((item: any, idx: number) => {
                    if (item instanceof Object) {
                        Object.keys(item).forEach((_key: any) => {
                            const val = item[_key];
                            // Skip undefined/null/empty values so backend can use general fallbacks
                            if (val !== undefined && val !== null && val !== '') {
                                // Use the exact format backend expects: worker_total[0]worker_id (no brackets or dots between index and field name)
                                formData.append(`${key}[${idx}]${_key}`, val);
                            }
                        });
                        indexFiles++;
                    } else if (item instanceof File) {
                        formData.append(key + '[]', item);
                    } else {
                        formData.append(key, JSON.stringify(item));
                    }
                });
            } else {
                Object.keys(data[key]).forEach((subKey) => {
                    if (data[key][subKey] instanceof File) {
                        formData.append(`${key}[${subKey}]`, data[key][subKey]);
                    } else {
                        formData.append(`${key}[${subKey}]`, JSON.stringify(data[key][subKey]));
                    }
                });
            }
        } else {
            formData.append(key, data[key]);
        }
    });
    return formData;
};
